// import { useState } from "react";
// import { getItems, importItems, deleteItem } from "../api";

// export default function ImportPage() {
//   const [rawText, setRawText] = useState(
//     "face(v)\nat(предлог времени)\nI have already finished my work(answer: have finished)"
//   );
//   const [result, setResult] = useState(null);
//   const [items, setItems] = useState([]);
//   const [loadingImport, setLoadingImport] = useState(false);
//   const [loadingItems, setLoadingItems] = useState(false);
//   const [deletingId, setDeletingId] = useState("");
//   const [error, setError] = useState("");
//   const [warnings, setWarnings] = useState([]);
//   async function handleImport() {
//     setLoadingImport(true);
//     setError("");
//     setResult(null);

//     try {
//       const data = await importItems(rawText);
//       setResult(data);
//     } catch (err) {
//       setError(err.message || "Import failed");
//     } finally {
//       setLoadingImport(false);
//     }
//   }

//   function splitRawUnits(rawText) {
//   return String(rawText || "")
//     .replace(/\r/g, "")
//     .split(/\n|;|·/)
//     .map((s) => s.trim())
//     .filter(Boolean);
// }

// function extractHint(rawUnit) {
//   const m = String(rawUnit).trim().match(/^(.*?)\s*\(([^()]*)\)\s*$/);
//   if (!m) return null;

//   const marker = (m[2] || "").trim();
//   if (marker.toLowerCase().startsWith("answer:")) return null; // это не hint
//   return marker;
// }

// function collectShortHintWarnings(rawText) {
//   const units = splitRawUnits(rawText);
//   const out = [];

//   for (const u of units) {
//     const hint = extractHint(u);
//     if (!hint) continue;

//     if (hint.trim().length < 2) {
//       out.push(`"${u}": hint "${hint}" слишком короткий (минимум 2 символа), модель может понять неверно.`);
//     }
//   }

//   return out;
// }
//   async function handleLoadItems() {
//     setLoadingItems(true);
//     setError("");

//     try {
//       const data = await getItems(20);
//       setItems(Array.isArray(data) ? data : []);
//     } catch (err) {
//       setError(err.message || "Failed to load items");
//     } finally {
//       setLoadingItems(false);
//     }
//   }

//   async function handleDeleteItem(id) {
//     if (!window.confirm("Delete this card?")) return;

//     setError("");
//     setDeletingId(id);

//     try {
//       await deleteItem(id);
//       setItems((prev) => prev.filter((x) => x._id !== id));
//     } catch (err) {
//       setError(err.message || "Failed to delete item");
//     } finally {
//       setDeletingId("");
//     }
//   }

//   return (
//     <div className="stack">
//       <section className="card">
//         <h2>Import words and phrases</h2>
//         <p className="muted">
//           Use <code>;</code>, new line, or <code>·</code> as separators.
//         </p>

//         <textarea
//           className="textarea"
//           rows={10}
//           value={rawText}
//           onChange={(e) => setRawText(e.target.value)}
//           placeholder="face(v); at(предлог времени); I have already finished my work(answer: have finished)"
//         />

//         <div className="row">
//           <button onClick={handleImport} disabled={loadingImport || !rawText.trim()}>
//             {loadingImport ? "Importing..." : "Import"}
//           </button>

//           <button onClick={handleLoadItems} disabled={loadingItems}>
//             {loadingItems ? "Loading..." : "Load saved items"}
//           </button>
//         </div>

//         {error ? <div className="alert error">{error}</div> : null}
//       </section>

//       {result ? (
//         <section className="card">
//           <h3>Import result</h3>

//           <div className="stats">
//             <div className="stat">
//               <span>Total</span>
//               <strong>{result.total}</strong>
//             </div>
//             <div className="stat">
//               <span>Created</span>
//               <strong>{result.created}</strong>
//             </div>
//             <div className="stat">
//               <span>Skipped</span>
//               <strong>{result.skipped}</strong>
//             </div>
//             <div className="stat">
//               <span>Failed</span>
//               <strong>{result.failed}</strong>
//             </div>
//           </div>

//           <div className="stack-sm">
//             {Array.isArray(result.results) &&
//               result.results.map((entry, index) => (
//                 <div className="result-item" key={`${entry.rawInput}-${index}`}>
//                   <div className="row-between">
//                     <strong>{entry.rawInput}</strong>
//                     <span
//                       className={
//                         entry.status === "created"
//                           ? "badge success"
//                           : entry.status === "skipped"
//                             ? "badge warning"
//                             : "badge danger"
//                       }
//                     >
//                       {entry.status}
//                     </span>
//                   </div>

//                   {entry.item ? <div>item: {entry.item}</div> : null}
//                   {entry.type ? <div>type: {entry.type}</div> : null}
//                   {entry.reason ? <div>reason: {entry.reason}</div> : null}
//                   {entry.error ? <div className="error-text">error: {entry.error}</div> : null}

//                   {entry.gptRaw ? (
//                     <details>
//                       <summary>GPT raw</summary>
//                       <pre className="pre-wrap">{entry.gptRaw}</pre>
//                     </details>
//                   ) : null}
//                 </div>
//               ))}
//           </div>
//         </section>
//       ) : null}

//       {items.length > 0 ? (
//         <section className="card">
//           <h3>Saved items</h3>

//           <div className="stack-sm">
//             {items.map((item) => (
//               <div className="result-item" key={item._id}>
//                 <div className="row-between">
//                   <strong>{item.item}</strong>

//                   <div className="row">
//                     <span className="badge">{item.type}</span>
//                     <button
//                       onClick={() => handleDeleteItem(item._id)}
//                       disabled={deletingId === item._id}
//                     >
//                       {deletingId === item._id ? "Deleting..." : "Delete"}
//                     </button>
//                   </div>
//                 </div>

//                 <div>translate: {item.translate}</div>
//                 <div>meaning: {item.meaning}</div>
//                 <div>meaningRu: {item.meaningRu}</div>

//                 {Array.isArray(item.examples) && item.examples.length > 0 ? (
//                   <details>
//                     <summary>Examples ({item.examples.length})</summary>
//                     <div className="stack-xs">
//                       {item.examples.map((ex, idx) => (
//                         <div key={idx} className="nested-box">
//                           <div>{ex.en}</div>
//                           <div className="muted">{ex.ru}</div>
//                         </div>
//                       ))}
//                     </div>
//                   </details>
//                 ) : null}

//                 {Array.isArray(item.practice) && item.practice.length > 0 ? (
//                   <details>
//                     <summary>Practice ({item.practice.length})</summary>
//                     <div className="stack-xs">
//                       {item.practice.map((p, idx) => (
//                         <div key={idx} className="nested-box">
//                           <div>{p.en}</div>
//                           <div className="muted">{p.ru}</div>
//                           <div>answer: {Array.isArray(p.answer) ? p.answer.join(" | ") : ""}</div>
//                         </div>
//                       ))}
//                     </div>
//                   </details>
//                 ) : null}
//               </div>
//             ))}
//           </div>
//         </section>
//       ) : null}
//     </div>
//   );
// }


// // import { useState } from "react";
// // import { getItems, importItems } from "../api";
// // import { getItems, importItems, deleteItem } from "../api";



// // async function handleDeleteItem(id) {
// //   if (!window.confirm("Delete this card?")) return;

// //   setError("");
// //   try {
// //     await deleteItem(id);
// //     setItems((prev) => prev.filter((x) => x._id !== id));
// //   } catch (err) {
// //     setError(err.message || "Failed to delete item");
// //   }
// // }

// // export default function ImportPage() {
// //   const [rawText, setRawText] = useState(
// //     "face(v)\nat(предлог времени)\nI have already finished my work(answer: have finished)"
// //   );
// //   const [result, setResult] = useState(null);
// //   const [items, setItems] = useState([]);
// //   const [loadingImport, setLoadingImport] = useState(false);
// //   const [loadingItems, setLoadingItems] = useState(false);
// //   const [error, setError] = useState("");

// //   async function handleImport() {
// //     setLoadingImport(true);
// //     setError("");
// //     setResult(null);

// //     try {
// //       const data = await importItems(rawText);
// //       setResult(data);
// //     } catch (err) {
// //       setError(err.message || "Import failed");
// //     } finally {
// //       setLoadingImport(false);
// //     }
// //   }

// //   async function handleLoadItems() {
// //     setLoadingItems(true);
// //     setError("");

// //     try {
// //       const data = await getItems(20);
// //       setItems(Array.isArray(data) ? data : []);
// //     } catch (err) {
// //       setError(err.message || "Failed to load items");
// //     } finally {
// //       setLoadingItems(false);
// //     }
// //   }

// //   return (
// //     <div className="stack">
// //       <section className="card">
// //         <h2>Import words and phrases</h2>
// //         <p className="muted">
// //           Use <code>;</code>, new line, or <code>·</code> as separators.
// //         </p>

// //         <textarea
// //           className="textarea"
// //           rows={10}
// //           value={rawText}
// //           onChange={(e) => setRawText(e.target.value)}
// //           placeholder="face(v); at(предлог времени); I have already finished my work(answer: have finished)"
// //         />

// //         <div className="row">
// //           <button onClick={handleImport} disabled={loadingImport || !rawText.trim()}>
// //             {loadingImport ? "Importing..." : "Import"}
// //           </button>

// //           <button onClick={handleLoadItems} disabled={loadingItems}>
// //             {loadingItems ? "Loading..." : "Load saved items"}
// //           </button>
// //         </div>

// //         {error ? <div className="alert error">{error}</div> : null}
// //       </section>

// //       {result ? (
// //         <section className="card">
// //           <h3>Import result</h3>

// //           <div className="stats">
// //             <div className="stat">
// //               <span>Total</span>
// //               <strong>{result.total}</strong>
// //             </div>
// //             <div className="stat">
// //               <span>Created</span>
// //               <strong>{result.created}</strong>
// //             </div>
// //             <div className="stat">
// //               <span>Skipped</span>
// //               <strong>{result.skipped}</strong>
// //             </div>
// //             <div className="stat">
// //               <span>Failed</span>
// //               <strong>{result.failed}</strong>
// //             </div>
// //           </div>

// //           <div className="stack-sm">
// //             {Array.isArray(result.results) &&
// //               result.results.map((entry, index) => (
// //                 <div className="result-item" key={`${entry.rawInput}-${index}`}>
// //                   <div className="row-between">
// //                     <strong>{entry.rawInput}</strong>
// //                     <span
// //                       className={
// //                         entry.status === "created"
// //                           ? "badge success"
// //                           : entry.status === "skipped"
// //                             ? "badge warning"
// //                             : "badge danger"
// //                       }
// //                     >
// //                       {entry.status}
// //                     </span>
// //                   </div>

// //                   {entry.item ? <div>item: {entry.item}</div> : null}
// //                   {entry.type ? <div>type: {entry.type}</div> : null}
// //                   {entry.reason ? <div>reason: {entry.reason}</div> : null}
// //                   {entry.error ? <div className="error-text">error: {entry.error}</div> : null}

// //                   {entry.gptRaw ? (
// //                     <details>
// //                       <summary>GPT raw</summary>
// //                       <pre className="pre-wrap">{entry.gptRaw}</pre>
// //                     </details>
// //                   ) : null}
// //                 </div>
// //               ))}
// //           </div>
// //         </section>
// //       ) : null}

// //       {items.length > 0 ? (
// //         <section className="card">
// //           <h3>Saved items</h3>

// //           <div className="stack-sm">
// //             {items.map((item) => (
// //               <div className="result-item" key={item._id}>
// //                 <div className="row-between">
// //                   <strong>{item.item}</strong>
// //                   <span className="badge">{item.type}</span>
// //                 </div>

// //                 <div>translate: {item.translate}</div>
// //                 <div>meaning: {item.meaning}</div>
// //                 <div>meaningRu: {item.meaningRu}</div>

// //                 {Array.isArray(item.examples) && item.examples.length > 0 ? (
// //                   <details>
// //                     <summary>Examples ({item.examples.length})</summary>
// //                     <div className="stack-xs">
// //                       {item.examples.map((ex, idx) => (
// //                         <div key={idx} className="nested-box">
// //                           <div>{ex.en}</div>
// //                           <div className="muted">{ex.ru}</div>
// //                         </div>
// //                       ))}
// //                     </div>
// //                   </details>
// //                 ) : null}

// //                 {Array.isArray(item.practice) && item.practice.length > 0 ? (
// //                   <details>
// //                     <summary>Practice ({item.practice.length})</summary>
// //                     <div className="stack-xs">
// //                       {item.practice.map((p, idx) => (
// //                         <div key={idx} className="nested-box">
// //                           <div>{p.en}</div>
// //                           <div className="muted">{p.ru}</div>
// //                           <div>answer: {Array.isArray(p.answer) ? p.answer.join(" | ") : ""}</div>
// //                         </div>
// //                       ))}
// //                     </div>
// //                   </details>
// //                 ) : null}
// //               </div>
// //             ))}
// //           </div>
// //         </section>
// //       ) : null}
// //     </div>
// //   );
// // }


import { useState } from "react";
import { getItems, importItems, deleteItem } from "../api";

/* ---------- warnings helpers (frontend only) ---------- */

function splitRawUnits(rawText) {
  return String(rawText || "")
    .replace(/\r/g, "")
    .split(/\n|;|·/)
    .map((s) => s.trim())
    .filter(Boolean);
}

function extractHint(rawUnit) {
  const m = String(rawUnit).trim().match(/^(.*?)\s*\(([^()]*)\)\s*$/);
  if (!m) return null;

  const marker = (m[2] || "").trim();
  if (marker.toLowerCase().startsWith("answer:")) return null; // это не hint
  return marker;
}

function collectShortHintWarnings(rawText) {
  const units = splitRawUnits(rawText);
  const out = [];

  for (const u of units) {
    const hint = extractHint(u);
    if (!hint) continue;

    if (hint.trim().length < 2) {
      out.push(
        `"${u}": hint "${hint}" слишком короткий (минимум 2 символа), модель может понять неверно.`
      );
    }
  }

  return out;
}

/* ----------------------------------------------------- */

export default function ImportPage() {
  const [rawText, setRawText] = useState(
    "face(v)\nat(предлог времени)\nI have already finished my work(answer: have finished)"
  );
  const [result, setResult] = useState(null);
  const [items, setItems] = useState([]);
  const [loadingImport, setLoadingImport] = useState(false);
  const [loadingItems, setLoadingItems] = useState(false);
  const [deletingId, setDeletingId] = useState("");
  const [error, setError] = useState("");
  const [warnings, setWarnings] = useState(collectShortHintWarnings(rawText));

  async function handleImport() {
    setLoadingImport(true);
    setError("");
    setResult(null);

    // пересчёт перед отправкой (на всякий случай)
    setWarnings(collectShortHintWarnings(rawText));

    try {
      const data = await importItems(rawText);
      setResult(data);
    } catch (err) {
      setError(err.message || "Import failed");
    } finally {
      setLoadingImport(false);
    }
  }

  async function handleLoadItems() {
    setLoadingItems(true);
    setError("");

    try {
      const data = await getItems(20);
      setItems(Array.isArray(data) ? data : []);
    } catch (err) {
      setError(err.message || "Failed to load items");
    } finally {
      setLoadingItems(false);
    }
  }

  async function handleDeleteItem(id) {
    if (!window.confirm("Delete this card?")) return;

    setError("");
    setDeletingId(id);

    try {
      await deleteItem(id);
      setItems((prev) => prev.filter((x) => x._id !== id));
    } catch (err) {
      setError(err.message || "Failed to delete item");
    } finally {
      setDeletingId("");
    }
  }

  return (
    <div className="stack">
      <section className="card">
        <h2>Import words and phrases</h2>
        <p className="muted">
          Use <code>;</code>, new line, or <code>·</code> as separators.
        </p>

        <textarea
          className="textarea"
          rows={10}
          value={rawText}
          onChange={(e) => {
            const next = e.target.value;
            setRawText(next);
            setWarnings(collectShortHintWarnings(next)); // предупреждаем сразу
          }}
          placeholder="face(v); at(предлог времени); I have already finished my work(answer: have finished)"
        />

        <div className="row">
          <button onClick={handleImport} disabled={loadingImport || !rawText.trim()}>
            {loadingImport ? "Importing..." : "Import"}
          </button>

          <button onClick={handleLoadItems} disabled={loadingItems}>
            {loadingItems ? "Loading..." : "Load saved items"}
          </button>
        </div>

        {warnings.length > 0 ? (
          <div className="alert info">
            <strong>Warnings:</strong>
            <div className="stack-xs" style={{ marginTop: 8 }}>
              {warnings.map((w, i) => (
                <div key={i}>{w}</div>
              ))}
            </div>
          </div>
        ) : null}

        {error ? <div className="alert error">{error}</div> : null}
      </section>

      {result ? (
        <section className="card">
          <h3>Import result</h3>

          <div className="stats">
            <div className="stat">
              <span>Total</span>
              <strong>{result.total}</strong>
            </div>
            <div className="stat">
              <span>Created</span>
              <strong>{result.created}</strong>
            </div>
            <div className="stat">
              <span>Skipped</span>
              <strong>{result.skipped}</strong>
            </div>
            <div className="stat">
              <span>Failed</span>
              <strong>{result.failed}</strong>
            </div>
          </div>

          <div className="stack-sm">
            {Array.isArray(result.results) &&
              result.results.map((entry, index) => (
                <div className="result-item" key={`${entry.rawInput}-${index}`}>
                  <div className="row-between">
                    <strong>{entry.rawInput}</strong>
                    <span
                      className={
                        entry.status === "created"
                          ? "badge success"
                          : entry.status === "skipped"
                            ? "badge warning"
                            : "badge danger"
                      }
                    >
                      {entry.status}
                    </span>
                  </div>

                  {entry.item ? <div>item: {entry.item}</div> : null}
                  {entry.type ? <div>type: {entry.type}</div> : null}
                  {entry.reason ? <div>reason: {entry.reason}</div> : null}
                  {entry.error ? <div className="error-text">error: {entry.error}</div> : null}

                  {entry.gptRaw ? (
                    <details>
                      <summary>GPT raw</summary>
                      <pre className="pre-wrap">{entry.gptRaw}</pre>
                    </details>
                  ) : null}
                </div>
              ))}
          </div>
        </section>
      ) : null}

      {items.length > 0 ? (
        <section className="card">
          <h3>Saved items</h3>

          <div className="stack-sm">
            {items.map((item) => (
              <div className="result-item" key={item._id}>
                <div className="row-between">
                  <strong>{item.item}</strong>

                  <div className="row">
                    <span className="badge">{item.type}</span>
                    <button
                      onClick={() => handleDeleteItem(item._id)}
                      disabled={deletingId === item._id}
                    >
                      {deletingId === item._id ? "Deleting..." : "Delete"}
                    </button>
                  </div>
                </div>

                <div>translate: {item.translate}</div>
                <div>meaning: {item.meaning}</div>
                <div>meaningRu: {item.meaningRu}</div>

                {Array.isArray(item.examples) && item.examples.length > 0 ? (
                  <details>
                    <summary>Examples ({item.examples.length})</summary>
                    <div className="stack-xs">
                      {item.examples.map((ex, idx) => (
                        <div key={idx} className="nested-box">
                          <div>{ex.en}</div>
                          <div className="muted">{ex.ru}</div>
                        </div>
                      ))}
                    </div>
                  </details>
                ) : null}

                {Array.isArray(item.practice) && item.practice.length > 0 ? (
                  <details>
                    <summary>Practice ({item.practice.length})</summary>
                    <div className="stack-xs">
                      {item.practice.map((p, idx) => (
                        <div key={idx} className="nested-box">
                          <div>{p.en}</div>
                          <div className="muted">{p.ru}</div>
                          <div>answer: {Array.isArray(p.answer) ? p.answer.join(" | ") : ""}</div>
                        </div>
                      ))}
                    </div>
                  </details>
                ) : null}
              </div>
            ))}
          </div>
        </section>
      ) : null}
    </div>
  );
}